// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldShare = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.574 8.48672C13.3274 8.48672 13.1207 8.30005 13.094 8.05338C12.934 6.58672 12.1474 5.26672 10.934 4.42672C10.714 4.27338 10.6607 3.97338 10.814 3.75338C10.9674 3.53338 11.2674 3.48005 11.4874 3.63338C12.934 4.64005 13.8674 6.21338 14.0607 7.95338C14.0874 8.22005 13.894 8.46005 13.6274 8.48672C13.6074 8.48672 13.594 8.48672 13.574 8.48672Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.49418 8.52013C2.48084 8.52013 2.46084 8.52013 2.44751 8.52013C2.18084 8.49347 1.98751 8.25347 2.01418 7.9868C2.19418 6.2468 3.11418 4.67347 4.54751 3.66013C4.76084 3.5068 5.06751 3.56013 5.22084 3.77347C5.37418 3.99347 5.32084 4.29347 5.10751 4.4468C3.90751 5.30013 3.12751 6.62013 2.98084 8.08013C2.95418 8.33347 2.74084 8.52013 2.49418 8.52013Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.6591 14.0666C9.83909 14.4599 8.95909 14.6599 8.03909 14.6599C7.07909 14.6599 6.16576 14.4466 5.31242 14.0132C5.07242 13.8999 4.97909 13.6066 5.09909 13.3666C5.21242 13.1266 5.50576 13.0332 5.74576 13.1466C6.16576 13.3599 6.61242 13.5066 7.06576 13.5932C7.67909 13.7132 8.30576 13.7199 8.91909 13.6132C9.37242 13.5332 9.81909 13.3932 10.2324 13.1932C10.4791 13.0799 10.7724 13.1732 10.8791 13.4199C10.9991 13.6599 10.9058 13.9532 10.6591 14.0666Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.0343 1.33984C7.00096 1.33984 6.1543 2.17984 6.1543 3.21984C6.1543 4.25984 6.9943 5.09984 8.0343 5.09984C9.0743 5.09984 9.9143 4.25984 9.9143 3.21984C9.9143 2.17984 9.0743 1.33984 8.0343 1.33984Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.36633 9.24707C2.33299 9.24707 1.48633 10.0871 1.48633 11.1271C1.48633 12.1671 2.32633 13.0071 3.36633 13.0071C4.40633 13.0071 5.24633 12.1671 5.24633 11.1271C5.24633 10.0871 4.39966 9.24707 3.36633 9.24707Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.6339 9.24707C11.6006 9.24707 10.7539 10.0871 10.7539 11.1271C10.7539 12.1671 11.5939 13.0071 12.6339 13.0071C13.6739 13.0071 14.5139 12.1671 14.5139 11.1271C14.5139 10.0871 13.6739 9.24707 12.6339 9.24707Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldShare };
